import { usePricingUsageFeeBillFailed } from './usePricingUsageFeeBillFailed';
import { usePricingUsageFeeCurrent } from './usePricingUsageFeeCurrent';

interface IPricingBilling {
  isLockedAppByBillFailed: boolean;
}

export const usePricingBilling = (): IPricingBilling => {
  const { isOverBasicTier } = usePricingUsageFeeCurrent();
  const { hasBillFailedAfterThresholdDay } = usePricingUsageFeeBillFailed();

  const isLockedAppByBillFailed = hasBillFailedAfterThresholdDay && isOverBasicTier;

  return {
    isLockedAppByBillFailed,
  };
};
